// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__3K_rE","actionsCol":"EnrolledClinics_actionsCol__1SMam"};